// Location utility functions for frontend
// Default location is Kochi, Kerala, India

export const DEFAULT_LOCATION = {
    latitude: 9.9312,
    longitude: 76.2673,
    city: 'Kochi',
    district: 'Ernakulam',
    state: 'Kerala',
    country: 'India'
};

const STORAGE_KEY = 'guestLocation';

/**
 * Get the default location (Kochi, India)
 */
export const getDefaultLocation = () => ({
    ...DEFAULT_LOCATION,
    loading: false,
    error: null,
    isDefault: true,
    source: 'default'
});

/**
 * Get guest location from localStorage
 * Returns null if no guest location is stored
 */
export const getLocationFromStorage = () => {
    try {
        const stored = localStorage.getItem(STORAGE_KEY);
        if (stored) {
            const parsed = JSON.parse(stored);
            return {
                ...parsed,
                isDefault: false,
                source: 'guest_saved'
            };
        }
        return null;
    } catch (error) {
        console.error('Error reading guest location from storage:', error);
        return null;
    }
};

/**
 * Save guest location to localStorage
 */
export const saveLocationToStorage = (location) => {
    try {
        const toStore = {
            latitude: location.latitude,
            longitude: location.longitude,
            city: location.city,
            district: location.district,
            state: location.state,
            country: location.country
        };
        localStorage.setItem(STORAGE_KEY, JSON.stringify(toStore));
        console.log('✅ Guest location saved to localStorage');
    } catch (error) {
        console.error('Error saving guest location to storage:', error);
    }
};

/**
 * Clear guest location from localStorage
 * Call this when user logs in to prevent mixing guest and user locations
 */
export const clearLocationFromStorage = () => {
    try {
        localStorage.removeItem(STORAGE_KEY);
        console.log('🗑️ Guest location cleared from localStorage');
    } catch (error) {
        console.error('Error clearing guest location from storage:', error);
    }
};

/**
 * Format location for UI display
 */
export const formatLocationDisplay = (location) => {
    if (!location) return 'Location not set';

    if (location.isDefault) {
        return `Default: ${location.city}, ${location.state}`;
    }

    if (location.city && location.district) {
        return `${location.city}, ${location.district}`;
    }

    if (location.city) {
        return location.city;
    }

    return 'Custom Location';
};

/**
 * Check if location is valid (has coordinates)
 */
export const isValidLocation = (location) => {
    return location &&
        typeof location.latitude === 'number' &&
        typeof location.longitude === 'number' &&
        !isNaN(location.latitude) &&
        !isNaN(location.longitude);
};
